 export default function attachInput() {
    $('#attachment-curriculum').on('change', function() {
        const labelText = document.getElementById('file-curriculum')
        const fileName = this.files[0]?.name || 'Arquivo'
        labelText.textContent = fileName
    })
     
     $('#attachment-product').on('change', function() {
        const labelText = document.getElementById('file-product')
        const fileName = this.files[0]?.name || 'Arquivo'
        labelText.textContent = fileName
    })

}
